export default __webpack_public_path__ + "static/media/cancel.bcfa7026.png";